import { Box, Button, Container, Divider, Typography } from "@mui/material";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";

const AffiliatePublicPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Box sx={{ bgcolor: '#e6f5fc' }}>
                <Container>
                    <Box sx={{ maxWidth: '100%' }} component="img" src="/static/images/affiliate.png" alt="Affiliate" />
                </Container>
            </Box>
            <Container>
                <Typography variant="h1" sx={{ mt: 2, textAlign: 'center', mb: 2 }}>
                    Join Our Affiliate Program
                </Typography>
                <Typography sx={{ mb: 3, fontSize: '1.2rem' }}>
                    Welcome to our Affiliate Program! We’re excited to invite you to become a part of our growing community. Whether you’re a seasoned marketer or just starting out, our program offers a fantastic opportunity for everyone.
                </Typography>

                <Typography variant="h2">
                    Why Join Us?
                </Typography>

                <Box component="ul" sx={{ pl: 3, mb: 3 }}>
                    <li>
                        <Typography sx={{ fontSize: '1.2rem' }}>
                            <b>Generous Commission Rate:</b> Earn a remarkable <b>50% commission</b> on every sale you generate. Our competitive rates ensure you’re rewarded for your efforts.
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={{ fontSize: '1.2rem' }}>
                        <b>Easy to Promote:</b> Our products are high-quality and appealing to a wide audience, making it easy for you to share with your network.          
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={{ fontSize: '1.2rem' }}>
                        <b>Supportive Community:</b> Gain access to a wealth of resources, including promotional materials, tips, and dedicated support to help you succeed.          
                        </Typography>
                    </li>
                </Box>

                <Typography variant="h2">
                    How It Works
                </Typography>

                <Box component="ol" sx={{ pl: 3, mb: 3 }}>
                    <li>
                        <Typography sx={{ fontSize: '1.2rem' }}>
                            <b>Sign Up:</b> Joining is quick and easy. Simply fill out our online sign up form to get started.
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={{ fontSize: '1.2rem' }}>
                        <b>Promote:</b> Use your unique affiliate link to promote our products through your website, blog, social media, or email.
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={{ fontSize: '1.2rem' }}>
                            <b>Earn:</b> For every sale made through your link, you’ll earn a 50% commission. It’s that simple!
                        </Typography>
                    </li>
                </Box>

                <Typography variant="h2">
                    Who Can Join?
                </Typography>

                <Typography sx={{ mb: 3, fontSize: '1.2rem' }}>
                    Our affiliate program is open to everyone! Whether you have a large audience or are just starting out, you can participate and start earning right away.
                </Typography>

                <Typography variant="h2">
                    Get Started Today!
                </Typography>

                <Typography sx={{ mb: 3, fontSize: '1.2rem' }}>
                    Don’t miss out on this opportunity to turn your passion into profit. Sign up for our Affiliate Program today and start earning generous commissions on every sale!
                </Typography>
                <Typography sx={{ mb: 3, fontSize: '1.2rem' }}>
                    For more information or any questions, feel free to contact us. We’re here to help you every step of the way!
                </Typography>

                <Divider />

                <Box sx={{ textAlign: 'center', my: 4 }}>
                    <Button disableElevation component={NavLink} to="/register?back=/app/affiliate" size="large" variant="contained" >
                        Join us and let’s succeed together!
                    </Button>
                </Box>
            </Container>
            </>
    );
};

export default AffiliatePublicPage;